import React, {useState, useContext} from 'react';
import {Typography, Divider, ClickAwayListener} from '@material-ui/core';
import "../../../../../../App.css";
import {Grid, Checkbox} from '@mantine/core';
import {useFormikContext} from "formik";
import {makeStyles, styled} from "@material-ui/core/styles";
import PopOverDetails from "../../../../../PopOverInfo";
import AffinityInfoContext from "../../../../../../context/AffinityContext";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";
import {IconBike, IconCamera, IconDeviceLaptop, IconDeviceTablet, IconScooter} from "@tabler/icons";

const useStyles = makeStyles(() => ({
    coverageIcon: {
        width: "32px",
        height: "32px",
        strokeWidth: "2px",
    },
    tableHeaderContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingRight: "64px",
    },
    tableHeader: {
        fontFamily: 'EncodeSansBold',
        fontSize: 20,
        display: "inline"
    },
    tableRowLabel: {
        fontFamily: 'Nunito'
    },
    arrow: {
        fontSize: 16,
        "&::before": {
            backgroundColor: "#FFF",
            color: "#FFF",
            boxShadow: '8px 2px 8px #888888',
            border: '1px solid #dadde9',
        }
    },
}));

const HtmlTooltip = styled(({className, arrowClass, handleCloseTooltip, ...props}) => (
    <ClickAwayListener onClickAway={handleCloseTooltip}>
        <Tooltip {...props} classes={{popper: className, arrow: arrowClass}}/>
    </ClickAwayListener>
))(({}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        fontSize: "14px",
        color: 'rgba(0, 0, 0, 0.87)',
        padding: "8px",
        boxShadow: "6px 10px 16px #888888",
        maxWidth: "264px",
        textAlign: "center",
        border: '1px solid #dadde9',
    },
}));

export default function CoberturasForm() {
    const {coberturasInfo} = useContext(AffinityInfoContext);
    const classes = useStyles();
    const {values, setFieldValue} = useFormikContext();
    const [openTooltip, setOpenTooltip] = useState(true);
    const coberturasAdicionalesIcons = {
        26: <IconCamera className={classes.coverageIcon}/>,
        36: <IconDeviceLaptop className={classes.coverageIcon}/>,
        37: <IconDeviceTablet className={classes.coverageIcon}/>,
        48: <IconBike className={classes.coverageIcon}/>,
        49: <IconScooter className={classes.coverageIcon}/>,
    }

    const handleCloseTooltip = () => {
        setOpenTooltip(false);
    };

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={12}>
                    <div className={classes.tableHeaderContainer}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>
                </Grid.Col>

                {Object.keys(values.coberturas).map((cobertura, index) => {
                    return (
                        <>
                            <Grid.Col xs={1} md={7}>
                                <Typography className={classes.tableRowLabel}>
                                    {coberturasInfo[cobertura].descripcion}
                                </Typography>
                            </Grid.Col>
                            {index === 0 ? (
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <p>Presionando aquí, podrás modificar los montos asegurados
                                                sugeridos</p>
                                        </React.Fragment>
                                    }
                                    arrow
                                    arrowClass={classes.arrow}
                                    open={openTooltip}
                                    handleCloseTooltip={handleCloseTooltip}
                                    placement="bottom-end"
                                >
                                    <Grid.Col xs={1} md={4}>
                                        <MantineNumberField
                                            name={`coberturas.${cobertura}.sumaAsegurada`}
                                            label={""}
                                            min={coberturasInfo[cobertura]['sumaMinima']}
                                            max={coberturasInfo[cobertura]['sumaMaxima']}
                                            styles={{input: {textAlign: "right"}}}
                                        />
                                    </Grid.Col>
                                </HtmlTooltip>
                            ) : (
                                <Grid.Col xs={1} md={4}>
                                    <MantineNumberField
                                        name={`coberturas.${cobertura}.sumaAsegurada`}
                                        label={""}
                                        min={coberturasInfo[cobertura]['sumaMinima']}
                                        max={coberturasInfo[cobertura]['sumaMaxima']}
                                        styles={{input: {textAlign: "right"}}}
                                    />
                                </Grid.Col>
                            )}
                            <Grid.Col xs={1} md={1}>
                                <PopOverDetails
                                    descripcion={coberturasInfo[cobertura].descripcionCompleta}/>
                            </Grid.Col>

                            <Grid.Col xs={12} md={12}>
                                <Divider light/>
                            </Grid.Col>

                        </>
                    )
                })}

                <Grid.Col xs={12} sm={12}>
                    <Typography className={classes.tableHeader} style={{margin: "32px 0px 16px 16px"}}>
                        Adicionales
                    </Typography>
                </Grid.Col>

                {Object.keys(values.coberturasAdicionales).map(cobertura => {
                    return (
                        <>
                            <Grid.Col xs={1} sm={1}>
                                <Checkbox
                                    checked={values.coberturasAdicionales[cobertura].selectedCobertura}
                                    classNames={{
                                        input: "checkbox",
                                        root: "checkbox",
                                        body: "checkbox",
                                    }}
                                    size="sm"
                                    onChange={(e) => {
                                        const {checked} = e.target;
                                        setFieldValue(`coberturasAdicionales.[${cobertura}].selectedCobertura`, checked);
                                    }}
                                />
                            </Grid.Col>
                            <Grid.Col xs={1} sm={1}>
                                {coberturasAdicionalesIcons[cobertura]}
                            </Grid.Col>
                            <Grid.Col xs={5} sm={5}>
                                <Typography className={classes.tableRowLabel}>
                                    {coberturasInfo[cobertura].descripcion}
                                </Typography>
                            </Grid.Col>
                            <Grid.Col xs={4} sm={4} style={{
                                visibility: values.coberturasAdicionales[cobertura] && values.coberturasAdicionales[cobertura].selectedCobertura ? "visible" : "hidden"
                            }}>

                                <MantineNumberField
                                    name={`coberturasAdicionales.${cobertura}.sumaAsegurada`}
                                    min={coberturasInfo[cobertura]['sumaMinima']}
                                    max={coberturasInfo[cobertura]['sumaMaxima']}
                                    styles={{input: {textAlign: "right"}}}
                                />
                            </Grid.Col>
                            <Grid.Col xs={1} sm={1}>
                                <PopOverDetails
                                    descripcion={coberturasInfo[cobertura].descripcionCompleta}
                                />
                            </Grid.Col>
                        </>
                    )
                })}
            </Grid>
        </React.Fragment>
    );
}
